// extracted by mini-css-extract-plugin
module.exports = {"container":"footer_container__1fBny","copy":"footer_copy__2d4bT","links":"footer_links__1zoT_","link":"footer_link__18eHP","img":"footer_img__2q4S5"};